import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppId } from '../../../model';
import { WhispDebugView } from './whisp-debug';

@Injectable({ providedIn: 'root' })
export class WhispDebugService {
  private readonly http = inject(HttpClient);

  async load(siteId: AppId): Promise<WhispDebugView | null> {
    try {
      return await firstValueFrom(this.http.get<WhispDebugView | null>(`api/site/${siteId}/whisp/debug`));
    } catch {
      return null;
    }
  }
}
